import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import EventsComponent from '../../components/Events';
import { getOrgEventsRequest } from '../../actionCreators/events';
import { getUserOrganisationRequest } from '../../actionCreators/organisationActions';

const Events = (props) => <EventsComponent {...props} />;

const EventsContainer = (props) => {
  const state = useSelector((state) => ({
    account: state.account,
    currentUser: state.currentUser,
    events: state.events.orgEventsList,
    customAppId: state.customApp.id,
    organisation: state.organisation.currentOrganisation,
  }));

  const dispatch = useDispatch();

  const actions = {
    getEvents: (payload) => dispatch(getOrgEventsRequest(payload)),
    getUserOrganisation: (payload) => dispatch(getUserOrganisationRequest(payload)),
  };

  return <Events {...props} {...state} {...actions} />;
};

export default EventsContainer;
